import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:pointer-events-none disabled:shadow-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0',
  {
    variants: {
      variant: {
        // V3 (2026-07-02) : hover:bg-primary/90 (opacity) échouait AA sous la teinte teal
        // (4.33:1, seuil 4.5:1) - remplacé par un token hover pré-calculé AA-safe.
        default:
          'bg-primary text-primary-foreground shadow hover:bg-primary-hover disabled:bg-primary-disabled disabled:text-muted-foreground',
        destructive:
          'bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 disabled:bg-destructive-soft disabled:text-muted-foreground',
        outline:
          'border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground disabled:bg-muted disabled:text-muted-foreground',
        // hover:bg-secondary/80 échouait AA sous le corail (3.55:1) - même fix.
        secondary:
          'bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary-hover disabled:bg-secondary-soft disabled:text-muted-foreground',
        ghost: 'hover:bg-accent hover:text-accent-foreground disabled:text-muted-foreground',
        link: 'text-primary underline-offset-4 hover:underline disabled:text-muted-foreground',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)
